import React from 'react'

import { useQuery } from '../hooks/useQuery'

const withSkillDescription = BaseComponent => props => {
  const operation = 'studentAppSkillDescription'

  const defaultVariables = {
    skill: { value: '', type: 'String', required: true },
  }

  const { data, refetch, loading: loadingSkillDescription } = useQuery(operation, defaultVariables, {
    lazy: true,
  })

  const skillDescription = !loadingSkillDescription && !data ? 'Description Unavailable' : data
  return (
    <BaseComponent
      {...props}
      getSkillDescription={refetch}
      skillDescription={skillDescription}
      loadingSkillDescription={loadingSkillDescription}
    />
  )
}

export default withSkillDescription



// WEBPACK FOOTER //
// ./src/utils/graphql/hocs/withSkillDescription.js